import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE } from '../../brands/default/content/components/checkout';
import { getGiftPackDetails } from '../../helpers/checkout';
import ThemeContext from '../../providers/ThemeProvider';
import { removeProductFromBasket } from '../../redux/actions/basket';

export default function BasketDealProductDelete({ bt, giftWrap, product }) {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const checkoutData = useSelector((state) => state.checkout.checkoutData);
  const onDelete = () => {
    if (product.gifting.giftPackProductId) {
      const addedGiftPack = getGiftPackDetails(
        checkoutData.deals,
        product.gifting.giftPackProductId,
      );
      dispatch(removeProductFromBasket(bt, product, addedGiftPack, giftWrap));
    } else {
      dispatch(removeProductFromBasket(bt, product, null, giftWrap));
    }
  };

  return (
    <>
      <button
        aria-label={DELETE}
        className="button__delete"
        onClick={onDelete}
        type="button"
      >
        <FontAwesomeIcon
          className="button__delete-icon"
          icon={faTrash}
          style={{ height: 20, width: 20 }}
        />
      </button>
      <style jsx>{`
        .button__delete {
          background-color: transparent;
          border: 1px solid #b3b3b3;
          border-radius: 5px;
          color: #333333;
          height: 34px;
          margin-top: 8px;
          padding: 6px;
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .button__delete {
            width: 34px;
          }
        }
      `}</style>
    </>
  );
}

BasketDealProductDelete.propTypes = {
  bt: PropTypes.string,
  giftWrap: PropTypes.object,
  product: PropTypes.object,
};
